import { render } from "./AudioWave.vue?vue&type=template&id=a3477da2"
import script from "./AudioWave.vue?vue&type=script&lang=js"
export * from "./AudioWave.vue?vue&type=script&lang=js"

import "./AudioWave.vue?vue&type=style&index=0&id=a3477da2&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__